import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Typography from '@mui/material/Typography';
import {getLabelMinute, trimText} from "../../globalMethods/utils";
import TimelapseIcon from '@mui/icons-material/Timelapse';
import {useMediaQuery, useTheme} from "@mui/material";

export default function AlignItemsList({eventShows, playingEvent, player}) {

    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

    return (
        <List sx={{
            width: '100%',
            minWidth: isDesktop? 360 : 160,
            maxHeight: '80vh',
            borderRadius:10,
            overflowY: 'auto',
            // --- Custom Scrollbar Styles for WebKit Browsers (Chrome, Safari, Edge) ---
            '&::-webkit-scrollbar': {
                width: '8px', // Width of the scrollbar
            },
            '&::-webkit-scrollbar-track': {
                backgroundColor: '#f1f1f1', // Light gray track
                borderRadius: '10px',
            },
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#888', // Darker gray thumb
                borderRadius: '10px',
                border: '2px solid #f1f1f1', // Gives a slight gap/padding
            },
            '&::-webkit-scrollbar-thumb:hover': {
                backgroundColor: '#555', // Even darker gray on hover
            }
        }}>

            {eventShows?.map((myEvents) =>  {
                let color ="white"
                if(myEvents?.broadcastId?.includes(playingEvent.broadcastId)){
                    color = "#0d6efd"
                }
                const startEventTime = (new Date(Date.parse(myEvents?.startDate)))

                if(startEventTime.getTime()> Date.now()) {
                    color = "red"
                }

                return  <div key={myEvents?.broadcastId}>
                    <ListItem onClick={()=> {
                        if(!color.includes("red")){

                            const  newValue  = startEventTime.getTime() / 1000
                            const nowTime = Date.now() / 1000
                            const  minMinimum =  nowTime - 28800

                            if (newValue > minMinimum){
                                if (newValue < nowTime) {
                                    player?.seekTo({wallClockTime: newValue});
                                }
                            }
                        }
                     }
                    } alignItems="center">
                        <ListItemAvatar sx={{ marginRight:5}}>
                            <img style={{maxWidth: isDesktop? 100: 60, maxHeight: isDesktop? 120 :80, borderRadius: 2}} loading={"lazy"}
                                 alt={myEvents?.title}
                                 src= {myEvents.picture?.replace("{resolutionXY}","170x95/filters:quality(80)") }/>
                        </ListItemAvatar>
                        <ListItemText

                            primary= {
                                <Typography
                                    component="span"
                                    variant="body2"
                                    sx={{ color: color, fontFamily:"Orbitron", fontSize:isDesktop? 20 : 10, display: 'inline' }}
                                >
                                    {trimText(myEvents?.title, 30)}
                                </Typography>
                            }
                            secondary={
                                <React.Fragment>
                                    <Typography
                                        component="span"
                                        variant="body2"
                                        sx={{ color: color, fontFamily:"Orbitron", fontSize:isDesktop? 20 : 10, display: 'inline' }}
                                    >
                                        {trimText(myEvents?.subTitle, 30)}
                                       <TimelapseIcon sx={{marginRight:2, marginLeft:2}}></TimelapseIcon> {getLabelMinute(new Date(Date.parse(myEvents?.startDate)))} - {getLabelMinute(new Date(Date.parse(myEvents?.endDate)))}

                                    </Typography>

                                </React.Fragment>
                            }
                        />

                    </ListItem>
                    <hr style={{ color:"white"}}>
                    </hr>
                </div>
            })}


        </List>
    );
}